import { ZopBrandingConfig } from '@zopup/zop-ux-core';

/**
 * Inflewz Main App Branding Configuration
 *
 * This configuration defines the branding assets used across the Inflewz application.
 * All shared UI components will automatically use these assets.
 */
export const INFLEWZ_MAIN_APP_BRANDING_CONFIG: ZopBrandingConfig = {
  appName: 'Inflewz',

  // Default logos (used as fallback)
  // NOTE: "Light" logo has light colors for use on DARK backgrounds
  //       "Dark" logo has dark colors for use on LIGHT backgrounds
  logoLightUrl: 'assets/images/logo/inflewz-text-logo-light-transparent-bg.svg',
  logoDarkUrl: 'assets/images/logo/inflewz-text-logo-dark-transparent-bg.svg',

  // Full logos with text (for headers, footers, large displays)
  logoFullLightUrl: 'assets/images/logo/inflewz-text-logo-light-transparent-bg.svg',
  logoFullDarkUrl: 'assets/images/logo/inflewz-text-logo-dark-transparent-bg.svg',

  // Square/compact logos (for mobile, small spaces, favicons)
  // Note: Square logos have solid backgrounds that work well for brand consistency
  logoSquareLightUrl: 'assets/images/logo/inflewz-logo-light.svg',
  logoSquareDarkUrl: 'assets/images/logo/inflewz-logo-dark.svg',

  logoAlt: 'Inflewz - Verified Business Platform',
  faviconUrl: 'assets/images/logo/android-chrome-192x192.png',

  images: {
    // Add custom images here as needed
    // Example: authHero: 'assets/images/auth/hero.svg'
  },
  animations: {
    // Add custom animations here as needed
    // Example: authHero: 'assets/animation/inflewz-hero.json'
  },

  // Theme colors for navigation and UI elements
  themeColors: {
    sidebarBgColor: '#19274d', // Inflewz brand color for sidebar background
    sidebarTextColor: '#ffffff', // White text for contrast on dark background
    sidebarNavColor: '#4a90e2', // Light blue accent for navigation items
  },
};
